import {loadStripe} from '@stripe/stripe-js';
let stripePromise;
const getStripe = () => {
  if (!stripePromise) {
    stripePromise = loadStripe('pk_live_51IHGm2GisCHFeAQzD2RW5AyrNZig1GG4COobpYfkJXLCdaZBwutrFWBYFTFoqBcm3uh8y0MjPrExA87nD9TtcUC700dctXcapF');
  }
  return stripePromise;
};
export default getStripe;
